import { gql } from "apollo-boost";

export const GET_SUBJECT = gql`
  query getSubject($id: ID!) {
    getSubject(
      id: $id
    ) {
      id
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
    }
  }
`;

export const GET_SUBJECTS = gql`
  query getSubjects {
    getSubjects {
      id
#      degree{
#        id code nameLocal nameEng
#      }
#      subjectGroup{
#        id code nameLocal nameEng
#      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
      label
    }
  }
`;

export const GET_SUBJECTS_DDL = gql`
  query getSubjects {
    getSubjects {
      id
      degree{
        id
      }
      subjectGroup{
        id
      }
      code
      nameLocal
      nameEng
      creditCalGrade
      creditDesc
      label
    }
  }
`;

export const GET_SUBJECT_BY_SUBJECTGROUP_ID = gql`
  query getSubjectsBySubjectGroup($subjectGroupId: ID!) {
    getSubjectsBySubjectGroup(
      subjectGroupId: $subjectGroupId
    ) {
      id
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
      label
    }
  }
`;

export const GET_SUBJECT_BY_CODE_OR_NAME = gql`
  query getSubjectsByCodeOrName($codeOrName: String!) {
    getSubjectsByCodeOrName(
      codeOrName: $codeOrName
    ) {
      id
            degree{
              id code nameLocal nameEng
            }
            subjectGroup{
              id code nameLocal nameEng
            }
      code
      nameLocal
      nameEng
      creditCalGrade
      creditDesc
      label
    }
  }
`;

export const ADD_SUBJECT = gql`
  mutation addSubject(
    $subjectInput: SubjectInput,
    $degreeId: ID!,
    $subjectGroupId: ID!
  ) {
    addSubject (
      subjectInput: $subjectInput,
      degreeId: $degreeId,
      subjectGroupId: $subjectGroupId
    ) {
      id
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
    }
  }
`;

export const UPDATE_SUBJECT = gql`
  mutation updateSubject(
    $id: ID!,
    $subjectInput: SubjectInput!,
    $degreeId: ID!,
    $subjectGroupId: ID!
  ) {
    updateSubject (
      id: $id,
      subjectInput: $subjectInput,
      degreeId: $degreeId,
      subjectGroupId: $subjectGroupId
    ) {
      id
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
    }
  }
`;

export const DELETE_SUBJECT = gql`
  mutation deleteSubject(
    $id: ID!
  ) {
    deleteSubject (
      id: $id
    ) {
      id
      degree{
        id code nameLocal nameEng
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      code
      nameLocal
      nameEng
      description
      creditCalGrade
      creditDesc
    }
  }
`;

